import { getResume } from '../helpers/utils'
import { SHOW_SELECTED_JOB } from '../actions/TimeLineActions'

const initialState = {
 resume: getResume(),
 currentItem: []
}


function ResumeReducer(state=initialState, action){

  switch(action.type){

    case SHOW_SELECTED_JOB:
      let selectedItem = state.resume.filter((d)=>{return d.id==action.payload})
      if (!selectedItem[0].hasOwnProperty('desc'))
        return Object.assign({}, state, {currentItem: ["Need to add description"]})
      return Object.assign({}, state, {currentItem: selectedItem[0]})

    
    default:
      return state
  }
}

export default ResumeReducer


// WEBPACK FOOTER //
// ./app/reducers/ResumeReducer.js